import { CalendarClock, CalendarDays, Users, Camera, ShieldCheck, Heart, CheckCircle2, AlertTriangle, CreditCard } from "lucide-react";

const CARDS = [
  { key: "active_sessions", label: "Active Sessions", icon: CalendarDays },
  { key: "upcoming_this_week", label: "Upcoming This Week", icon: CalendarClock },
  { key: "registered_strangers", label: "Registered Strangers", icon: Users },
  { key: "active_photographers", label: "Active Photographers", icon: Camera },
  { key: "pending_photographer_approvals", label: "Pending Approvals", icon: ShieldCheck },
  { key: "pending_matches", label: "Pending Matches", icon: Heart },
  { key: "completed_sessions", label: "Completed Sessions", icon: CheckCircle2 },
  { key: "open_safety_reports", label: "Open Safety Reports", icon: AlertTriangle },
];

export const DashboardStats = ({ stats }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="dashboard-stats-grid">
    {CARDS.map(({ key, label, icon: Icon }) => (
      <div key={key} className="border border-soft-gray rounded-2xl p-5" data-testid={`dashboard-stat-${key}`}>
        <Icon className="w-5 h-5 text-stranger-orange mb-3" />
        <p className="text-2xl font-extrabold">{stats[key]}</p>
        <p className="text-xs font-bold uppercase tracking-wide text-midnight-black/60 mt-1">{label}</p>
      </div>
    ))}
    <div className="border border-soft-gray rounded-2xl p-5" data-testid="dashboard-stat-revenue">
      <CreditCard className="w-5 h-5 text-stranger-orange mb-3" />
      <p className="text-sm font-extrabold text-midnight-black/50">Payments module not configured</p>
      <p className="text-xs font-bold uppercase tracking-wide text-midnight-black/60 mt-1">Revenue</p>
    </div>
  </div>
);
